import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { View, Text } from 'react-native';
import { ButtonGroup } from '../../ButtonGroup/rn';
import { Popup } from '../../Popup/rn';
import { replaceParams } from '../../../utils/tools';
import { CustomStyleSheet } from '../../../utils/rn/tools';
import { useLocale } from '../../LocaleProvider/rn';
export var ChannelBtnType;
(function (ChannelBtnType) {
  ChannelBtnType["BtnLive"] = "btn_live";
  ChannelBtnType["BtnSubmitWebform"] = "btn_submit_webform";
  ChannelBtnType["BtnGeneralCall"] = "btn_general_call";
  ChannelBtnType["BtnVirtualCall"] = "btn_virtual_call";
})(ChannelBtnType || (ChannelBtnType = {}));
export var ChannelOptionButtonsPopup = function ChannelOptionButtonsPopup(props) {
  var active = props.active,
    onClose = props.onClose,
    buttons = props.buttons;
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  return /*#__PURE__*/React.createElement(Popup, {
    active: active,
    onClose: onClose,
    showCloseButton: true,
    closeButtonText: trans('channel_selection_cancel_btn'),
    contentStyle: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    layout: "vertical",
    buttons: buttons.map(function (v) {
      var _v$extraParam, _v$extraParam2;
      return _objectSpread(_objectSpread({}, v), {}, {
        children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
          style: styles.title
        }, /*#__PURE__*/React.createElement(ButtonIconSvg, {
          type: v.buttonType
        }), /*#__PURE__*/React.createElement(Text, {
          style: {
            marginLeft: 5,
            color: '#ee4d2d'
          }
        }, v.text)), ((_v$extraParam = v.extraParam) === null || _v$extraParam === void 0 ? void 0 : _v$extraParam.day) != null ? /*#__PURE__*/React.createElement(Text, {
          style: styles.description
        }, "(", replaceParams(v.extraParam.desc, {
          day: /*#__PURE__*/React.createElement(Text, {
            style: styles.day
          }, v.extraParam.day)
        }), ")") : /*#__PURE__*/React.createElement(Text, {
          style: styles.description
        }, "(", (_v$extraParam2 = v.extraParam) === null || _v$extraParam2 === void 0 ? void 0 : _v$extraParam2.desc, ")")),
        onClick: function onClick() {
          var _v$onClick;
          (_v$onClick = v.onClick) === null || _v$onClick === void 0 ? void 0 : _v$onClick.call(v);
          onClose();
        }
      });
    })
  }));
};
var ButtonIconSvg = function ButtonIconSvg(_ref) {
  var type = _ref.type;
  if (type === ChannelBtnType.BtnSubmitWebform) {
    return /*#__PURE__*/React.createElement(EmailSvg, null);
  }
  if (type === ChannelBtnType.BtnGeneralCall) {
    return /*#__PURE__*/React.createElement(PhoneSvg, null);
  }
  return null;
};
var EmailSvg = function EmailSvg() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33334 3.99984C1.33334 3.26346 1.9303 2.6665 2.66668 2.6665H13.3333C14.0697 2.6665 14.6667 3.26346 14.6667 3.99984V11.9998C14.6667 12.7362 14.0697 13.3332 13.3333 13.3332H2.66668C1.9303 13.3332 1.33334 12.7362 1.33334 11.9998V3.99984ZM2.66668 3.6665H13.3333C13.5174 3.6665 13.6667 3.81574 13.6667 3.99984V4.2878L8.00001 8.06558L2.33334 4.2878V3.99984C2.33334 3.81574 2.48258 3.6665 2.66668 3.6665ZM2.33334 5.48965V11.9998C2.33334 12.1839 2.48258 12.3332 2.66668 12.3332H13.3333C13.5174 12.3332 13.6667 12.1839 13.6667 11.9998V5.48965L8.27736 9.08253C8.10941 9.1945 7.89061 9.1945 7.72266 9.08253L2.33334 5.48965Z",
    fill: "#EE4D2D"
  }));
};
var PhoneSvg = function PhoneSvg() {
  return /*#__PURE__*/React.createElement(Svg, {
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M5.68901 1.71919C5.09209 1.01374 3.95089 0.801291 3.23056 1.57931C2.80962 2.03396 2.37992 2.62571 2.15401 3.30348C1.86005 4.18542 2.03241 5.27179 2.62081 6.47954C3.21303 7.69516 4.25479 9.09496 5.81033 10.6505L6.51743 9.94339C5.00885 8.43481 4.04715 7.12404 3.5198 6.04157C2.98861 4.95124 2.92527 4.15199 3.1027 3.61969C3.26715 3.12629 3.59698 2.65548 3.96435 2.25869C4.18705 2.01816 4.62594 2.01095 4.92563 2.36513L6.12985 3.7883C6.3537 4.05286 6.39046 4.42834 6.22216 4.73128L5.86509 5.37401C5.5487 5.94351 5.54975 6.66209 5.952 7.22064C6.28724 7.68615 6.80205 8.34239 7.46024 9.00058L8.16735 8.29348C7.5575 7.68362 7.07713 7.07179 6.76347 6.63625C6.60878 6.42146 6.59281 6.12324 6.73925 5.85965L7.09632 5.21692C7.46658 4.55045 7.38571 3.72438 6.89323 3.14236L5.68901 1.71919Z",
    fill: "#EE4D2D"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M14.7417 10.7718C15.4472 11.3687 15.6596 12.5099 14.8816 13.2303C14.427 13.6512 13.8352 14.0809 13.1574 14.3068C12.2755 14.6008 11.1891 14.4284 9.98138 13.84C8.76576 13.2478 7.36586 12.206 5.81033 10.6505L6.51743 9.94339C8.02602 11.452 9.33688 12.4137 10.4193 12.941C11.5097 13.4722 12.3089 13.5356 12.8412 13.3581C13.3346 13.1937 13.8054 12.8638 14.2022 12.4965C14.4428 12.2738 14.45 11.8349 14.0958 11.5352L12.6726 10.331C12.4081 10.1071 12.0326 10.0704 11.7296 10.2387L11.0869 10.5957C10.5174 10.9121 9.79882 10.9111 9.24028 10.5088C8.77477 10.1736 8.11844 9.65878 7.46024 9.00058L8.16735 8.29348C8.77721 8.90333 9.38913 9.3837 9.82466 9.69736C10.0395 9.85204 10.3377 9.86801 10.6013 9.72158L11.244 9.36451C11.9105 8.99425 12.7365 9.07511 13.3186 9.56759L14.7417 10.7718Z",
    fill: "#EE4D2D"
  }));
};
var styles = CustomStyleSheet({
  title: {
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  description: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: 12,
    lineHeight: 14
  },
  day: {
    color: '#ee4d2d',
    fontSize: 12,
    lineHeight: 14
  }
});